import React from 'react';
import { Dialog } from '@neptune/shared/venus-ui';
import { ProjectsLimitMessage } from '@neptune/shared/common-ui';

type ArchiveLimitReachedModalProps = {
  isOpen: boolean;
  close: () => void;
  organizationName: string;
};

export const ArchiveLimitReachedModal = ({
  isOpen,
  close,
  organizationName,
}: ArchiveLimitReachedModalProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      title="Cannot unarchive project"
      primaryButtonLabel="OK"
      role="cannot-unarchive-project-modal"
      onPrimaryButtonClick={close}
      onClose={close}
    >
      <ProjectsLimitMessage onLinkClick={close} organizationName={organizationName} />
    </Dialog>
  );
};
